import React, { useState, useEffect } from 'react'
import ReactApexChart from 'react-apexcharts'

import { Card, Typography } from 'antd'

import EmptyData from '../../../assets/images/ico_dashboard.svg'
import { getMessage } from '../../../util/IntlMessages'
import ChartHeader from '../../Dashboard/Cultivars/charts/ChartHeader'
import './GeneralProductivity.css'

const GeneralProductivity = ({ values }) => {
  const [hasData, setHasData] = useState(false)
  const [signalPercentsGain, setSignalPercentsGain] = useState('')
  const [reports, setReports] = useState([])

  useEffect(() => {
    if (values && values !== undefined) {
      const { check, i2x } = values

      if (check.avg !== Number(0) || i2x.avg !== Number(0)) {
        setHasData(true)
        setReports([{ data: [values.i2x.avg.toFixed(2), values.check.avg.toFixed(2)] }])
      }

      Number(values.totalGain) < 0 ? setSignalPercentsGain('') : setSignalPercentsGain('+')
    } else {
      setHasData(false)
      setReports([])
    }
  }, [values])

  const options = {
    options: {
      chart: {
        type: 'bar',
        toolbar: {
          show: false
        }
      },
      plotOptions: {
        bar: {
          distributed: true,
          horizontal: false,
          dataLabels: {
            position: 'top'
          }
        }
      },
      colors: ['#843EF7', '#04D1D1'],
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '12px',
          colors: ['#843EF7', '#04D1D1']
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
      },
      xaxis: {
        categories: ['Produtividade média I2x', 'Produtividade média check']
      },
      yaxis: {
        title: {
          show: 'none'
        },
        labels: {
          formatter(text) {
            return text
          }
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        enabled: false
      },
      legend: {
        show: false
      }
    }
  }

  function getI2xAvg() {
    if (values && values.i2x && values.i2x.avg) return values.i2x.avg
    return 0
  }

  function getCheckAvg() {
    if (values && values.check && values.check.avg) return values.check.avg
    return 0
  }

  return (
    <Card className="gereral-productivity">
      <ChartHeader title={getMessage('gereralProductivity')} />

      {hasData ? (
        <div className="content">
          <div className="right mr-10">
            <ReactApexChart type="bar" height={430} options={options.options} series={reports} />
          </div>

          <div className="right ml-10">
            <Card>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold', fontSize: '14px' }}>Produtividade média i2x</p>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                    <p style={{ fontWeight: 'bold', color: '#843EF7', fontSize: '29px', margin: '0px' }}>
                      {`${getI2xAvg() !== 0 ? getI2xAvg().toFixed(2) : 0} sc/ha`}
                    </p>
                  </div>
                </div>
              </div>
            </Card>

            <Card>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold', fontSize: '14px' }}>Produtividade média check</p>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                    <p style={{ fontWeight: 'bold', color: '#04D1D1', fontSize: '29px', margin: '0px' }}>
                      {`${getI2xAvg() !== 0 ? getCheckAvg().toFixed(2) : 0} sc/ha`}
                    </p>
                  </div>
                </div>
              </div>
            </Card>

            <Card>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <p style={{ fontWeight: 'bold', fontSize: '14px' }}>Ganho de produtividade</p>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <div style={{ display: 'flex', justifyContent: 'center', marginRight: '10px' }}>
                    <p style={{ fontWeight: 'bold', color: '#22C787', fontSize: '29px', margin: '0px' }}>
                      {`${getI2xAvg() !== 0 ? values.totalGain.toFixed(2) : 0} sc/ha`}
                    </p>
                  </div>
                  <div
                    style={{ borderRadius: '10px', background: '#7BE6BD', display: 'flex', justifyContent: 'center' }}
                  >
                    <p style={{ fontWeight: 'bold', color: '#FBFBFC', fontSize: '15px', margin: '10px' }}>
                      {`${signalPercentsGain}${values !== null ? values.percentsGain.toFixed(2) : 0}%`}
                    </p>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      ) : (
        <div style={{ width: '100%' }}>
          <div style={{ display: 'grid', placeItems: 'center', padding: 14, height: 292 }}>
            <img src={EmptyData} alt="FarmIcon" style={{ marginBottom: -30 }} />
            <Typography style={{ color: '#8591A1', fontWeight: 'bold', textAlign: 'center', fontSize: 14 }}>
              {'Sem dados'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -50 }}
            >
              {'Escolha materiais para exibir'}
            </Typography>
            <Typography
              style={{ color: '#8591A1', fontWeight: '500', textAlign: 'center', fontSize: 14, marginTop: -120 }}
            >
              {'esse relatório'}
            </Typography>
          </div>
        </div>
      )}
    </Card>
  )
}

export default GeneralProductivity
